module.exports = __webpack_public_path__ + "img/SHOPEE_ID.6f24fc7d.svg";